import React from 'react';
import logoIngenia from '../../assets/logos/logo-ingenia.png';
import logoIngenieria from '../../assets/logos/logo-ingenieria.png';
import './styles.css';

export const Footer = () => {
  return (
    <div id="Footer">
      <div className="FooterContainer">
        <p className="FooterTexto">Desarrollado por / Depeloped by</p>
        <div className="FooterLogos">
          <a
            className="FooterLogo"
            href="http://ingeniaudea.edu.co/portal/"
            target="_blank"
          >
            <img src={logoIngenia} alt="Logo Ingenia" />
          </a>
          <a
            className="FooterLogo"
            href="http://ingenieria.udea.edu.co/"
            target="_blank"
          >
            <img src={logoIngenieria} alt="Logo Ingeniería Udea" />
          </a>
        </div>
        <p className="FooterTexto">
          Dirección: Calle 70 No. 52 - 21 / Línea gratuita de atención al
          ciudadano 018000 416384
        </p>
        <p className="FooterTexto">
          Todos los derechos reservados - Universidad de Antioquia / Ingeni@ -
          Medellín &copy; 2020
        </p>
      </div>
    </div>
  );
};
